import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const TeamsV2TextCell = ({ team, column }: DataCellProps) => {
  const colId = typeof column === 'object' ? column.id : column;
  const value = team[colId as keyof typeof team];
  return <Box>{(value as React.ReactNode) ?? ''}</Box>;
};

export default TeamsV2TextCell;
